export default __webpack_public_path__ + "static/important-insurance-1a839e8584bb52f1239d645d0f02191f.png";